/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateItem200,
  ActivatePriceList200,
  AddItem200,
  CreatePriceList200,
  CreatePriceListItemRequest,
  CreatePriceListRequest,
  DeactivateItem200,
  DeactivatePriceList200,
  GetPriceList200,
  GetPriceListPdf200,
  PagedResponsePriceList,
  PriceList,
  PriceListItem,
  SearchPriceListsParams,
  UpdateItem200,
  UpdatePriceList200,
  UpdatePriceListItemRequest,
  UpdatePriceListRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List price lists for the caller's organisation
 */
export const listPriceLists = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<PriceList[]>(
      {url: `/api/v1/price-lists`, method: 'GET', signal
    },
      );
    }
  



export const getListPriceListsQueryKey = () => {
    return [
    `/api/v1/price-lists`
    ] as const;
    }

    
export const getListPriceListsQueryOptions = <TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPriceListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPriceLists>>> = ({ signal }) => listPriceLists(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPriceListsQueryResult = NonNullable<Awaited<ReturnType<typeof listPriceLists>>>
export type ListPriceListsQueryError = unknown


export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPriceLists>>,
          TError,
          Awaited<ReturnType<typeof listPriceLists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPriceLists>>,
          TError,
          Awaited<ReturnType<typeof listPriceLists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List price lists for the caller's organisation
 */

export function useListPriceLists<TData = Awaited<ReturnType<typeof listPriceLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPriceLists>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPriceListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new price list
 */
export const createPriceList = (
    createPriceListRequest: CreatePriceListRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreatePriceList200>(
      {url: `/api/v1/price-lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPriceListRequest, signal
    },
      );
    }
  


export const getCreatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: CreatePriceListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: CreatePriceListRequest}, TContext> => {

const mutationKey = ['createPriceList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPriceList>>, {data: CreatePriceListRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPriceList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof createPriceList>>>
    export type CreatePriceListMutationBody = CreatePriceListRequest
    export type CreatePriceListMutationError = unknown

    /**
 * @summary Create a new price list
 */
export const useCreatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPriceList>>, TError,{data: CreatePriceListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPriceList>>,
        TError,
        {data: CreatePriceListRequest},
        TContext
      > => {

      const mutationOptions = getCreatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List a price list's items
 */
export const listItems = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PriceListItem[]>(
      {url: `/api/v1/price-lists/${id}/items`, method: 'GET', signal
    },
      );
    }
  



export const getListItemsQueryKey = (id?: string,) => {
    return [
    `/api/v1/price-lists/${id}/items`
    ] as const;
    }

    
export const getListItemsQueryOptions = <TData = Awaited<ReturnType<typeof listItems>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListItemsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItems>>> = ({ signal }) => listItems(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listItems>>>
export type ListItemsQueryError = unknown


export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listItems>>,
          TError,
          Awaited<ReturnType<typeof listItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listItems>>,
          TError,
          Awaited<ReturnType<typeof listItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a price list's items
 */

export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListItemsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Add an item to a price list
 */
export const addItem = (
    id: string,
    createPriceListItemRequest: CreatePriceListItemRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddItem200>(
      {url: `/api/v1/price-lists/${id}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPriceListItemRequest, signal
    },
      );
    }
  


export const getAddItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addItem>>, TError,{id: string;data: CreatePriceListItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addItem>>, TError,{id: string;data: CreatePriceListItemRequest}, TContext> => {

const mutationKey = ['addItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addItem>>, {id: string;data: CreatePriceListItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addItem(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddItemMutationResult = NonNullable<Awaited<ReturnType<typeof addItem>>>
    export type AddItemMutationBody = CreatePriceListItemRequest
    export type AddItemMutationError = unknown

    /**
 * @summary Add an item to a price list
 */
export const useAddItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addItem>>, TError,{id: string;data: CreatePriceListItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addItem>>,
        TError,
        {id: string;data: CreatePriceListItemRequest},
        TContext
      > => {

      const mutationOptions = getAddItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single price list
 */
export const getPriceList = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetPriceList200>(
      {url: `/api/v1/price-lists/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPriceListQueryKey = (id?: string,) => {
    return [
    `/api/v1/price-lists/${id}`
    ] as const;
    }

    
export const getGetPriceListQueryOptions = <TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriceList>>> = ({ signal }) => getPriceList(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceListQueryResult = NonNullable<Awaited<ReturnType<typeof getPriceList>>>
export type GetPriceListQueryError = unknown


export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceList>>,
          TError,
          Awaited<ReturnType<typeof getPriceList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceList>>,
          TError,
          Awaited<ReturnType<typeof getPriceList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single price list
 */

export function useGetPriceList<TData = Awaited<ReturnType<typeof getPriceList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a price list (name, coefficient, validity — plType/parentId are immutable)
 */
export const updatePriceList = (
    id: string,
    updatePriceListRequest: UpdatePriceListRequest,
 ) => {
      
      
      return apiClient<UpdatePriceList200>(
      {url: `/api/v1/price-lists/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePriceListRequest
    },
      );
    }
  


export const getUpdatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: string;data: UpdatePriceListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: string;data: UpdatePriceListRequest}, TContext> => {

const mutationKey = ['updatePriceList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePriceList>>, {id: string;data: UpdatePriceListRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePriceList(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof updatePriceList>>>
    export type UpdatePriceListMutationBody = UpdatePriceListRequest
    export type UpdatePriceListMutationError = unknown

    /**
 * @summary Update a price list (name, coefficient, validity — plType/parentId are immutable)
 */
export const useUpdatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePriceList>>, TError,{id: string;data: UpdatePriceListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePriceList>>,
        TError,
        {id: string;data: UpdatePriceListRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a price list item (item code, category, description, unit, price, norm hours, sort order)
 */
export const updateItem = (
    id: string,
    itemId: string,
    updatePriceListItemRequest: UpdatePriceListItemRequest,
 ) => {
      
      
      return apiClient<UpdateItem200>(
      {url: `/api/v1/price-lists/${id}/items/${itemId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePriceListItemRequest
    },
      );
    }
  


export const getUpdateItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{id: string;itemId: string;data: UpdatePriceListItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{id: string;itemId: string;data: UpdatePriceListItemRequest}, TContext> => {

const mutationKey = ['updateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItem>>, {id: string;itemId: string;data: UpdatePriceListItemRequest}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  updateItem(id,itemId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateItem>>>
    export type UpdateItemMutationBody = UpdatePriceListItemRequest
    export type UpdateItemMutationError = unknown

    /**
 * @summary Update a price list item (item code, category, description, unit, price, norm hours, sort order)
 */
export const useUpdateItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{id: string;itemId: string;data: UpdatePriceListItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateItem>>,
        TError,
        {id: string;itemId: string;data: UpdatePriceListItemRequest},
        TContext
      > => {

      const mutationOptions = getUpdateItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate a price list item
 */
export const deactivateItem = (
    id: string,
    itemId: string,
 ) => {
      
      
      return apiClient<DeactivateItem200>(
      {url: `/api/v1/price-lists/${id}/items/${itemId}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateItem>>, TError,{id: string;itemId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateItem>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['deactivateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateItem>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deactivateItem(id,itemId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateItemMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateItem>>>
    
    export type DeactivateItemMutationError = unknown

    /**
 * @summary Deactivate a price list item
 */
export const useDeactivateItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateItem>>, TError,{id: string;itemId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateItem>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {

      const mutationOptions = getDeactivateItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Activate a price list item
 */
export const activateItem = (
    id: string,
    itemId: string,
 ) => {
      
      
      return apiClient<ActivateItem200>(
      {url: `/api/v1/price-lists/${id}/items/${itemId}/activate`, method: 'PATCH'
    },
      );
    }
  


export const getActivateItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateItem>>, TError,{id: string;itemId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateItem>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['activateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateItem>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  activateItem(id,itemId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateItemMutationResult = NonNullable<Awaited<ReturnType<typeof activateItem>>>
    
    export type ActivateItemMutationError = unknown

    /**
 * @summary Activate a price list item
 */
export const useActivateItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateItem>>, TError,{id: string;itemId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateItem>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {

      const mutationOptions = getActivateItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate a price list
 */
export const deactivatePriceList = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivatePriceList200>(
      {url: `/api/v1/price-lists/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePriceList>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivatePriceList>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivatePriceList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivatePriceList>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivatePriceList(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof deactivatePriceList>>>
    
    export type DeactivatePriceListMutationError = unknown

    /**
 * @summary Deactivate a price list
 */
export const useDeactivatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePriceList>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivatePriceList>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Activate a price list
 */
export const activatePriceList = (
    id: string,
 ) => {
      
      
      return apiClient<ActivatePriceList200>(
      {url: `/api/v1/price-lists/${id}/activate`, method: 'PATCH'
    },
      );
    }
  


export const getActivatePriceListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePriceList>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activatePriceList>>, TError,{id: string}, TContext> => {

const mutationKey = ['activatePriceList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePriceList>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activatePriceList(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivatePriceListMutationResult = NonNullable<Awaited<ReturnType<typeof activatePriceList>>>
    
    export type ActivatePriceListMutationError = unknown

    /**
 * @summary Activate a price list
 */
export const useActivatePriceList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePriceList>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activatePriceList>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getActivatePriceListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Generate a basic PDF printout of the price list
 */
export const getPriceListPdf = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetPriceListPdf200>(
      {url: `/api/v1/price-lists/${id}/pdf`, method: 'GET', signal
    },
      );
    }
  



export const getGetPriceListPdfQueryKey = (id?: string,) => {
    return [
    `/api/v1/price-lists/${id}/pdf`
    ] as const;
    }

    
export const getGetPriceListPdfQueryOptions = <TData = Awaited<ReturnType<typeof getPriceListPdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceListPdfQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPriceListPdf>>> = ({ signal }) => getPriceListPdf(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceListPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getPriceListPdf>>>
export type GetPriceListPdfQueryError = unknown


export function useGetPriceListPdf<TData = Awaited<ReturnType<typeof getPriceListPdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceListPdf>>,
          TError,
          Awaited<ReturnType<typeof getPriceListPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceListPdf<TData = Awaited<ReturnType<typeof getPriceListPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPriceListPdf>>,
          TError,
          Awaited<ReturnType<typeof getPriceListPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPriceListPdf<TData = Awaited<ReturnType<typeof getPriceListPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate a basic PDF printout of the price list
 */

export function useGetPriceListPdf<TData = Awaited<ReturnType<typeof getPriceListPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPriceListPdf>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceListPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable price list for the main Price Lists list page
 */
export const searchPriceLists = (
    params?: SearchPriceListsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponsePriceList>(
      {url: `/api/v1/price-lists/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchPriceListsQueryKey = (params?: SearchPriceListsParams,) => {
    return [
    `/api/v1/price-lists/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchPriceListsQueryOptions = <TData = Awaited<ReturnType<typeof searchPriceLists>>, TError = unknown>(params?: SearchPriceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchPriceListsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPriceLists>>> = ({ signal }) => searchPriceLists(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchPriceListsQueryResult = NonNullable<Awaited<ReturnType<typeof searchPriceLists>>>
export type SearchPriceListsQueryError = unknown


export function useSearchPriceLists<TData = Awaited<ReturnType<typeof searchPriceLists>>, TError = unknown>(
 params: undefined |  SearchPriceListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPriceLists>>,
          TError,
          Awaited<ReturnType<typeof searchPriceLists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchPriceLists<TData = Awaited<ReturnType<typeof searchPriceLists>>, TError = unknown>(
 params?: SearchPriceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPriceLists>>,
          TError,
          Awaited<ReturnType<typeof searchPriceLists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchPriceLists<TData = Awaited<ReturnType<typeof searchPriceLists>>, TError = unknown>(
 params?: SearchPriceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable price list for the main Price Lists list page
 */

export function useSearchPriceLists<TData = Awaited<ReturnType<typeof searchPriceLists>>, TError = unknown>(
 params?: SearchPriceListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPriceLists>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchPriceListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




